import { If } from 'components/ideal-core-ui'
import s from './BoardCardTasks.scss'
import { IoMdCheckboxOutline } from 'react-icons/io'
import cn from 'classnames'

const BoardCardTasks = ({ futureTasks, lateTasks, todayTasks, completedTasks }) => {
  const totalTasks =
    futureTasks.length + lateTasks.length + todayTasks.length + completedTasks.length
  if (totalTasks === 0) {
    return (
      <div className={s.task}>
        <span>no active tasks</span>
      </div>
    )
  }
  return (
    <div className={s.tasksWrapper}>
      <If condition={lateTasks.length}>
        <div title="Late Tasks" className={cn(s.late, s.task)}>
          <IoMdCheckboxOutline />{' '}
          <span>
            {lateTasks.length} / {totalTasks}
          </span>
        </div>
      </If>
      <If condition={todayTasks.length}>
        <div title="Tasks due Today" className={cn(s.today, s.task)}>
          <IoMdCheckboxOutline />{' '}
          <span>
            {todayTasks.length} / {totalTasks}
          </span>
        </div>
      </If>
      <If condition={futureTasks.length}>
        <div title="Future Tasks" className={cn(s.future, s.task)}>
          <IoMdCheckboxOutline />{' '}
          <span>
            {futureTasks.length} / {totalTasks}
          </span>
        </div>
      </If>
      <If condition={completedTasks.length}>
        <div title="Completed Tasks" className={cn(s.completed, s.task)}>
          <IoMdCheckboxOutline />{' '}
          <span>
            {completedTasks.length} / {totalTasks}
          </span>
        </div>
      </If>
    </div>
  )
}

export default BoardCardTasks
